import React, { Component } from "react";

import withStyles from "@material-ui/core/styles/withStyles";

import { MfaAppNotEnabled } from "./mfa-app-not-enabled";
import { MfaAppEnabled } from "./mfa-app-enabled";
import { MESSAGE_IDS } from "constants/message-ids";

const styles = ({ spacing }) => {
    return {
        line: {
            display: "flex",
            marginBottom: spacing.unit * 2,
        },
        number: {
            marginRight: spacing.unit * 2,
        },
        verify: {
            marginTop: spacing.unit * 2,
        },
        key: {
            fontWeight: "bold",
        },
        qrCode:{
            marginTop:spacing.unit*2,
            height: "auto",
            margin: "0 auto",
            width: "256px",            
        }
    };
};

class MfaEnableApp extends Component {
    state = {  };


    render() {
        const  {enabled,messages}=this.props;

        const title=messages[MESSAGE_IDS.MFA.APP_STEPS]
        const props={...this.props, title, messages}

        return enabled?<MfaAppEnabled {...props}/>:<MfaAppNotEnabled {...props}/>
    }
}

MfaEnableApp = withStyles(styles)(MfaEnableApp);

export { MfaEnableApp };
